export const CHANGE_CLOUD = 'CHANGE_CLOUD';
export const CHANGE_SERVICES = 'CHANGE_SERVICES';
export const ADD_SERVICE = 'ADD_SERVICE';
export const CHANGE_REGISTRY = 'CHANGE_REGISTRY';
